import { render, staticRenderFns } from "./EprescribeMacthedModal.vue?vue&type=template&id=732cfff3"
import script from "./EprescribeMacthedModal.vue?vue&type=script&lang=js"
export * from "./EprescribeMacthedModal.vue?vue&type=script&lang=js"
import style0 from "./EprescribeMacthedModal.vue?vue&type=style&index=0&id=732cfff3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports